module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voucher-history"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketsingleProgram'
      }
    }
  }, [_vm._v("单个项目消费明细")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketallProgram'
      }
    }
  }, [_vm._v("所有项目消费明细")])], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95c11ec4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/Main.vue
// module id = 603
// module chunks = 0